import { defineComponent as _defineComponent } from 'vue'
import CommonButton from '@/components/CommonButton.vue';
import { Constants } from '@/infra/constants/constants';
import { WhatsAppInfra } from '@/infra/whatsapp/whatsapp_infra';

export default /*#__PURE__*/_defineComponent({
  __name: 'CallToAction',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { CommonButton, get Constants() { return Constants }, get WhatsAppInfra() { return WhatsAppInfra } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})